import { RequireOnly } from '@pelicargo/types';
import { Quote, QuoteSource } from '@prisma/client';

type IntegrationUrlQuote = RequireOnly<Quote, 'sourced_by' | 'integration_order_id' | 'integration_booking_id'>;

/** Builds a link to the quote in the source integration's own UI, from its `integration_order_id` / `integration_booking_id`. */
const INTEGRATION_URL_BUILDERS: Partial<Record<QuoteSource, (quote: IntegrationUrlQuote) => string | undefined>> = {
  // NextGen quotes keep their CUDA quote id as the order id
  [QuoteSource.NEXTGEN]: ({ integration_order_id }) =>
    integration_order_id
      ? `https://customer.cudacartagetms.com/quotes/edit?id=${encodeURIComponent(integration_order_id)}`
      : undefined,
  // 7L quotes keep their QuoteNumber7L as the order id
  [QuoteSource.SEVENLFREIGHT]: ({ integration_order_id }) =>
    integration_order_id
      ? `https://7lfreight.com/secure/libs/CUSTOMER_QUOTE/customer_quote_pdf1.php?id=${encodeURIComponent(integration_order_id)}&dest=F`
      : undefined,
  // Echo has no order id; a booked quote keeps the Echo ShipmentId as its booking id
  [QuoteSource.ECHO]: ({ integration_booking_id }) =>
    integration_booking_id
      ? `https://www.echoship.com/shipments/${encodeURIComponent(integration_booking_id)}`
      : undefined,
};

/** A link to the quote in the integration it was sourced from, when that integration has one. */
export const integrationUrl = (quote?: IntegrationUrlQuote | null) => {
  if (!quote?.sourced_by) return undefined;
  return INTEGRATION_URL_BUILDERS[quote.sourced_by]?.(quote);
};
